<template>
  <div class="order-item">
    <div class="order-item-header">
      <div class="column">
        <div class="cell-title">{{ phrases.ORDER_NUMBER }}</div>
        <div class="cell-value">{{ orderHistory.number }}</div>
      </div>
      <div class="column column-right">
        <div class="cell-title">{{ phrases.DATE }}</div>
        <div class="cell-value">{{ orderHistory.date }}</div>
      </div>
      <div class="column column-right">
        <div class="cell-title">{{ phrases.SUM }}</div>
        <div class="cell-value">{{ orderHistory.sum }} <span class="currency">{{ phrases.TEXT_RUB }}</span></div>
      </div>
    </div>
    <div class="order-item-body" v-if="isOrderOpen">
      <div class="order-item-list">
        <div class="order-item-list-item" v-for="(orderItem, index) in orderHistory.items" :key="'orderItem-' + index"
          :class="{'disabled': orderItem.product === null}">
          <div class="order-item-list-item__image" :style="{ backgroundImage: 'url(' + orderItem.image + ')' }"></div>
          <div class="order-item-list-item__price price-top">{{orderItem.sum}} <span class="currency">{{ phrases.TEXT_RUB }}</span></div>
          <div class="order-item-list-item__title">{{ orderItem.title }}
            <div class="order-item-list-item__description" v-if="orderItem.product === null">{{ phrases.PRODUCT_UNAVAILABLE }}</div>
            <div class="order-item-list-item__description" v-else>x {{orderItem.quantity}} {{ phrases.PCS }}</div>
          </div>
          <div class="order-item-list-item__price price-bottom">{{orderItem.sum}} <span class="currency">{{ phrases.TEXT_RUB }}</span></div>
        </div>
      </div>
    </div>
    <div class="order-item-footer">
      <div class="personal__button button-order-detail" v-on:click="openOrder()">
        <span v-if="!isOrderOpen">{{ phrases.TEXT_READ_MORE }}</span>
        <span v-else>{{ phrases.TEXT_BUTTON_CANCEL }}</span>
      </div>
      <div class="personal__button button-order-repeat" v-if="isOrderOpen" v-on:click="openRepeat()">
        <span v-if="(!processing)">{{ phrases.TEXT_BUTTON_REPEAT_ORDER }}</span>
        <span v-else-if="isProcessingDiscount">{{ phrases.TEXT_WAITING_FOR_REQUEST }}</span>
        <span v-else>{{ phrases.TEXT_BUTTON_IN_BASKET }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../Utils";
import {mapGetters} from "vuex";

export default {
  name: "OrderHistoryItem",
  props: {
    orderHistory: {},
  },
  data: function (){
    return {
      isOrderOpen: false,
      processing: false,
    };
  },
  methods: {
    openOrder: function (){
      this.isOrderOpen = !this.isOrderOpen;
      this.processing = false;
    },
    openRepeat: function (){
      const component = this;
      component.processing = true;
      for (const orderItem of this.orderHistory.items){

        if(orderItem.product === null){
          continue;
        }

        const offer = (orderItem.dough !== null) ?
          this.prepareBasketOffer(orderItem.product, orderItem.offer, orderItem.dough) :
            this.prepareBasketOffer(orderItem.product, (orderItem.product.offers.length === 0 ? component.prepareSelectedProductWithoutOffer(orderItem.product) : component.prepareSelectedProductWithOffer(orderItem.product)), null);

        component.$store.dispatch({
          type: 'order/addToBasket',
          offer: offer,
        }).then( function () {
        });
      }
      component.calculateDiscount();
    },
  },
  computed: {
    ...mapGetters('catalog', {
        products: 'getProducts',
    }),
    ...mapGetters('app', {
        isProcessingDiscount: 'getProcessDiscount',
    }),
  },
  mixins: [Utils],
}
</script>

<style scoped>

</style>